export default {
    allok: {
        pos: 'top-center',
        type: 'success',
        message: {
            head: 'Hey it works!!!!',
            body: `This should come in handy`,
            break: true,
        },
    },
};
